import {BaseAppModel} from "./AppModel";

export enum TaskStatus {
    WAITING = "WAITING",
    PUBLISHING = "PUBLISHING",
    PUBLISHED = "PUBLISHED",
    PUBLISH_FAILED = "PUBLISH_FAILED",
    PUBLISH_OVERDUE = "PUBLISH_OVERDUE",
    RUNNING = "RUNNING",
    RUN = "RUN",
    RUN_FAILED = "RUN_FAILED",
    RUN_OVERDUE = "RUN_OVERDUE",
    CANCELLING = "CANCELLING",
    CANCELED = "CANCELED",
    CANCEL_FAILED = "CANCEL_FAILED",
    CANCEL_OVERDUE = "CANCEL_OVERDUE",
    EXPIRED = "EXPIRED"
}

export const taskStatusZh = {
    WAITING: "等待中",
    PUBLISHING: "发布中",
    PUBLISHED: "已发布",
    PUBLISH_FAILED: "发布失败",
    PUBLISH_OVERDUE: "发布逾期",
    RUNNING: "执行中",
    RUN: "已执行",
    RUN_FAILED: "执行失败",
    RUN_OVERDUE: "执行逾期",
    CANCELLING: "取消中",
    CANCELED: "已取消",
    CANCEL_FAILED: "取消失败",
    CANCEL_OVERDUE: "取消逾期",
    EXPIRED: "已过期"
}

export default class Task<T extends Task<T>> extends BaseAppModel<T> {
    name!: string
    desc!: string
    content?: string = undefined
    contentDesc?: string = undefined
    status!: TaskStatus

    startedAt!: Date
    startedAtPretty!: string
    expectedToRunAt!: Date
    expectedToRunAtPretty!: string
    runAt?: Date = undefined
    runAtPretty?: string = undefined
    spendTime?: number = undefined

    failReason?: string = undefined
    failStack?: string = undefined
    isFailed?: boolean = undefined

    userId?: number = undefined
    userName?: string = undefined

    taskGenId?: number = undefined
}
